export default {
    methods: {
        cropUsername(uname) {
            if(uname){
                return uname.length > 20 ? uname.substring(0, 20) + "..." : uname;
            }else{
                return ""
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixin/cropUsername.js